const FormValidation = (data) => {
  if (!data.estab?.trim()) {
    return validationError('Ingrese el nombre comercial')
  }

  if (!data.razon?.trim()) {
    return validationError('Ingrese la razón social')
  }

  if (!data.ruc?.trim()) {
    return validationError('Ingrese el RUC')
  }

  if (!/^\d+$/.test(data.ruc)) {
    return validationError('El RUC debe contener solo números')
  }

  if (data.ruc.length !== 13) {
    return validationError('El RUC debe tener 13 dígitos')
  }

  if (!data.name?.trim()) {
    return validationError('Ingrese el representante')
  }

  if (!/^[A-Za-zÀ-ÿ\s]+$/.test(data.name)) {
    return validationError('El representante solo debe contener letras')
  }

  if (!data.cedula?.trim()) {
    return validationError('Ingrese la cédula')
  }

  if (!/^\d+$/.test(data.cedula)) {
    return validationError('La cédula debe contener solo números')
  }

  if (data.cedula.length !== 10) {
    return validationError('La cédula debe tener 10 dígitos')
  }

  if (!data.email?.trim()) {
    return validationError('Ingrese el correo electrónico')
  }

  if (!isValidEmail(data.email)) {
    return validationError('Ingrese un correo válido')
  }

  if (!data.phone?.trim()) {
    return validationError('Ingrese el teléfono')
  }

  if (!/^\d+$/.test(data.phone)) {
    return validationError('El teléfono debe contener solo números')
  }

  if (data.phone.length !== 10) {
    return validationError('El teléfono debe tener 10 dígitos')
  }

  if (!data.dir?.trim()) {
    return validationError('Ingrese la dirección')
  }

  if (!data.provincia_id) {
    return validationError('Seleccione la provincia')
  }

  if (!data.canton_id) {
    return validationError('Seleccione el cantón')
  }

  if (!data.parroquia_id) {
    return validationError('Seleccione la parroquia')
  }

  if (!data.tipo_negocio?.length) {
    return validationError('Seleccione el tipo de negocio')
  }

  if (!data.plan) {
    return validationError('Seleccione un plan')
  }

  if (!data.terms) {
    return validationError('Debe aceptar términos y condiciones')
  }

  if (!data.data) {
    return validationError('Debe autorizar el tratamiento de datos')
  }

  return {
    error: false,
    message: ''
  }
}

const ContactValidation = (data) => {
  if (!data.name?.trim()) {
    return validationError('Ingrese su nombre')
  }

  if (!/^[A-Za-zÀ-ÿ\s]+$/.test(data.name)) {
    return validationError('El nombre solo debe contener letras')
  }

  if (!data.email?.trim()) {
    return validationError('Ingrese el correo electrónico')
  }

  if (!isValidEmail(data.email)) {
    return validationError('Ingrese un correo válido')
  }

  if (!data.phone?.trim()) {
    return validationError('Ingrese el teléfono')
  }

  if (!/^\d+$/.test(data.phone)) {
    return validationError('El teléfono debe contener solo números')
  }

  if (data.phone.length !== 10) {
    return validationError('El teléfono debe tener 10 dígitos')
  }

  if (!data.subject?.trim()) {
    return validationError('Ingrese el título')
  }

  if (!data.asunto?.trim()) {
    return validationError('Ingrese el asunto')
  }

  return {
    error: false,
    message: ''
  }
}

const validationError = (message) => {
  return {
    error: true,
    variant: 'warning',
    message
  }
}

const isValidEmail = (email) => {
  const validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/

  return validEmail.test(email)
}

const formValidation = {
  FormValidation,
  ContactValidation
}

export default formValidation
